import ImageCropModal from '../../../../../components/imageCropModal';
import AddStoryBS from '../../../../../module/newShop/home/AssStoryBS';
import SuccessStoryModal from '../../modal/successMyStoreModal';

interface ModalsProps {
  showCropModal: boolean;
  currentImage: File | null;
  onCropComplete: (file: File) => void;
  onCropClose: () => void;
  isSuccessModal: boolean;
  onSuccessModalClose: () => void;
  isAddStoryBsOpen: boolean;
  onAddStoryBsClose: () => void;
}

const Modals = ({
  showCropModal,
  currentImage,
  onCropComplete,
  onCropClose,
  isSuccessModal,
  onSuccessModalClose,
  isAddStoryBsOpen,
  onAddStoryBsClose,
}: ModalsProps) => (
  <>
    {showCropModal && currentImage && (
      <ImageCropModal
        originalFile={currentImage}
        onComplete={onCropComplete}
        onClose={onCropClose}
      />
    )}

    <SuccessStoryModal
      isSuccessModal={isSuccessModal}
      setIsSuccessModal={onSuccessModalClose}
    />

    <AddStoryBS open={isAddStoryBsOpen} setIsOpen={onAddStoryBsClose} />
  </>
);

export default Modals;
